import { ColorMatrixFilter } from 'pixi.js';

// Apply biome color grading to a ColorMatrixFilter based on wave tier.
// Resets the filter then layers saturate + hue (and brightness/contrast on later tiers).
export function applyBiomeGrade(cm: ColorMatrixFilter, wave: number): void {
  const w = wave || 1;
  cm.reset();
  if (w <= 4) {
    cm.saturate(0.14, true);
    cm.hue(-8, true);
  } else if (w <= 9) {
    cm.saturate(0.20, true);
    cm.hue(22, true);
  } else if (w <= 14) {
    cm.saturate(0.26, true);
    cm.contrast(0.10, true);
    cm.hue(-12, true);
  } else {
    cm.saturate(0.30, true);
    cm.brightness(1.08, true);
    cm.hue(36, true);
  }
}
